import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "External Components",
description: "How to embed non-native UI components in Freon projections—simple additions, wrappers, and replacers—plus required props, lifecycle hooks, and wiring.",
tags: [ "external components", "editor", "projections", "wrappers", "replacers", "Svelte", "Box Model", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T18:22:34.079Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};